import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { font } from '@/constant/font';
import { SccButton } from './SccButton';
export const SccPrimaryButton = ({ text, onPress, isDisabled = false, elementName, logParams, style, width, height = 56, fontSize = 18, leftIcon, rightIcon, }) => {
    return (_jsx(SccButton, { text: text, onPress: onPress, isDisabled: isDisabled, elementName: elementName, logParams: logParams, buttonColor: "brandColor", textColor: "white", fontFamily: font.pretendardSemibold, fontSize: fontSize, width: width, height: height, leftIcon: leftIcon, rightIcon: rightIcon, style: Object.assign({ borderRadius: 8 }, style) }));
};
